var map = {
	"./default/create": 353,
	"./phapa/create": 1092,
	"./special-events/create": 1095
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1241;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/pages ^\.\/.*\/create$
// module id = 1241
// module chunks = 0